//import { handleTabs } from '@/utils/routes'

export default {
  computed: {},
  watch: {},
  methods: {
    selectionChange(val) {
      this.currentRow = val
    },
    save() {
      this.$emit('save', { data: this.currentRow, vc: this })
    },
  },
}
